// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"e6831abc","296":"e6831abc","552":"e6831abc","673":"e6831abc","739":"c5ebc3ce","982":"e6831abc"}[chunkId] + ".chunk.css";
};